import React, { Fragment, useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Button from 'components/CustomButtons/Button.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.js';

//iconos
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';

// core components
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Close, Edit, Save } from '@material-ui/icons';

import { wsUpdate } from 'services/WService';

import Read from './Read.js';
import Write from './Write.js';
import { WithApp } from 'contexts/appContext.js';
import SellerModalConfirm from './SellerModalConfirm';
import { useModal } from 'hooks/useModal.js';

const useStyles = makeStyles((theme) => ({
  ...styles,
  title: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold',
    fontSize: '20px'
  },
  marginRight: {
    float: 'right',
    marginBottom: '10px'
  }
}));

export default WithApp(function Resumen(props) {
  const classes = useStyles();
  const { showNotify, businessPartner, reload } = props;

  const [isEdit, setIsEdit] = useState(false); //Editar general
  const [model, setModel] = useModal();

  const [generalData, setGeneralData] = useState({});

  const handleChange = (e) => {
    setGeneralData({
      ...generalData,
      [e.target.name]: e.target.value
    });
  };

  function validateSave(data) {
    if (data.QryGroup1 === 'N') {
      delete data.prefix;
      delete data.QryGroup2;
    }

    let newData = {};
    for (let key in data) {
      if (businessPartner[key] != data[key]) {
        newData[key] = data[key];
      }
    }

    if(newData.prom_bonification_validation !== undefined){
      if(parseFloat(newData.prom_bonification_validation) === 0){
        newData.prom_bonification_validation = null;
      }
    }

    if (newData.frozenFor !== undefined) {
      let msg = 'Activación';
      if (newData.frozenFor === 'Y') {
        msg = 'Inactivación';
      }
      setModel({
        msg,
        save: (sellerId, comment, type) => save({
          ...data,
          frozen_for_comment: comment,
          frozen_for_seller: sellerId,
          frozen_for_type: type,
        }),
      });
      return;
    }

    save(generalData);
  }

  async function save(data) {
    if (data.QryGroup1 === 'N') {
      delete data.prefix;
      delete data.QryGroup2;
    }

    let newData = {};
    for (let key in data) {
      if (businessPartner[key] != data[key]) {
        newData[key] = data[key];
      }
    }

    if(newData.prom_bonification_validation !== undefined){
      if(parseFloat(newData.prom_bonification_validation) === 0){
        newData.prom_bonification_validation = null;
      }
    }

    let response = await wsUpdate('base/business-partner', businessPartner.id, newData);
    if (response.success) {
      showNotify(response.message);
      setIsEdit(false);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    setGeneralData(businessPartner);
  }, [businessPartner]);

  return (
    <Fragment>
      <SellerModalConfirm model={model} setOpen={setModel} />
      <GridItem xs={12}>
        <AllowedGuard permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_SUMMARY_UPDATE}>
          {isEdit ? (
            <Fragment>
              <Button
                justIcon
                round
                color={props.themeContext.buttonColorDanger}
                className={classes.marginRight}
                onClick={() => setIsEdit(false)}
              >
                <Close className={classes.icons} />
              </Button>
              <Button
                justIcon
                round
                color={props.themeContext.buttonColorSuccess}
                className={classes.marginRight}
                onClick={() => {
                  validateSave(generalData);
                }}
              >
                <Save className={classes.icons} />
              </Button>
            </Fragment>
          ) : (
            <Button
              justIcon
              round
              color={props.themeContext.buttonColorWarning}
              className={classes.marginRight}
              onClick={() => setIsEdit(true)}
            >
              <Edit className={classes.icons} />
            </Button>
          )}
        </AllowedGuard>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColorSuccess}>
              <ContactPhoneIcon />
            </CardIcon>
            <div className={classes.title}>
              <span>Información General</span>
            </div>
          </CardHeader>
          <CardBody>
            {isEdit ? (
              <Write bPartner={generalData} handleChange={handleChange} />
            ) : (
              <Read bPartner={businessPartner} />
            )}
          </CardBody>
        </Card>
      </GridItem>
    </Fragment>
  );
});
